const API_BASE = '/api/referral'

export interface ReferralStats {
  code: string
  totalSignups: number
  totalPayments: number
  totalCreditsEarned: number
}

export interface ReferralEvent {
  referredUserId: string
  signupAt: string
  paymentAt: string
  signupCreditsPaid: boolean
  paymentCreditsPaid: boolean
}

export async function getReferralStats(): Promise<ReferralStats | null> {
  try {
    const response = await fetch(`${API_BASE}/me`, { credentials: 'include' })
    if (response.status === 401 || response.status === 404) return null
    if (!response.ok) return null
    return response.json()
  } catch {
    return null
  }
}

export async function getReferralEvents(): Promise<ReferralEvent[]> {
  try {
    const response = await fetch(`${API_BASE}/events`, { credentials: 'include' })
    if (!response.ok) return []
    const data = await response.json()
    return data.events || []
  } catch {
    return []
  }
}

export async function claimReferral(code: string): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE}/claim`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ code }),
    })
    if (!response.ok) return false
    const data = await response.json()
    return data.claimed === true
  } catch {
    return false
  }
}
